/**
 * useToggleCart.
 *  Реализация фичи для товара: добавление/удаление из корзины.
 *  Проверяет есть ли текущий товар в корзине
 *
 * @returns {{ isInCart: boolean, toggle: () => void }}
 * - Возварщает
 *  isInCart - флаг есть ли товар в корзине
 *  toggle   - метод который добавит или удалит товар из козины
 */


import {GoodsType} from "../../../../../entities/goods/model/types/goods-type";
import {useEffect, useState} from "react";
import {EventEmitter} from "../../../../../app/eventEmitter/EventEmitter";
import {EventsIfurn} from "../../../../../app/eventEmitter/Events";

export const useToggleCartIfurn = (goods: GoodsType) => {
    const [inCart, setInCart] = useState(false);

    // Запросить статус товара в корзине

    const requestStatus = (): Promise<boolean> => {
        const eventName = EventsIfurn.checkInCart;
        return new Promise(resolve => {
            EventEmitter.emit(eventName, {
                itemId: goods.id, //идентификатор товара
                callback: (inCart: boolean) => {
                    resolve(inCart);
                }
            });
        })
    }
    // При монтировании запрашиваем статус, есть ли товар в корзине
    useEffect(() => {
        requestStatus()
            .then((inCart) => {
                setInCart(inCart)
            })
            .catch((err) => {
                console.error(err);
                // Если ошибка — считаем, что товара нет
                setInCart(false);
            });
    }, [goods.id]);

    const addToCart = (): void => {
        const eventName = EventsIfurn.addToCart;
        EventEmitter.emit(eventName, {
            item: goods,
            callback: ({inCart}: { inCart: boolean }) => {
                setInCart(inCart);
            }
        });

    }
    const removeFromCart = (): void => {
        const eventName = EventsIfurn.removeFromCart;
        EventEmitter.emit(eventName, {
            item: goods,
            callback: ({inCart}: { inCart: boolean }) => {
                setInCart(inCart);
            }
        });

    }

    const toggleCart = (): void => {
        if (inCart) {
            removeFromCart();
            return;
        }
        addToCart();
    }
    return {
        inCart: inCart,
        toggleCart: toggleCart,
    };
};